export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2D1A13] text-[#FDFBF7] border-t border-[#FDFBF7]/10 pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <h2
        data-testid="footer-wordmark"
        className="font-serif-display font-black tracking-tighter leading-none text-[13.5vw] whitespace-nowrap text-[#FDFBF7]/95 select-none"
      >
        Ice Cream <span className="italic text-[#FF8E9E]">Social</span>
      </h2>
      <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-[11px] uppercase tracking-[0.25em] text-[#FDFBF7]/50 font-semibold">
        <span className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="Ice Cream Social logo" data-testid="footer-logo" className="h-[16px] w-auto" />
          © 2026 Ice Cream Social Studio
        </span>
        <span>Melts in your mind, not in your feed.</span>
        <a data-testid="footer-admin-link" href="/admin" className="hover:text-[#FF8E9E] transition-colors">
          Studio Login
        </a>
      </div>
    </div>
  </footer>
);
